<template>
  <div class="sizetab">
    <div class="drawer-card">
      <van-row style="margin-top: 3px">
        <van-col span="12">
          <van-button
            @click="bigClick"
            v-model="big"
            :color="a ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            Big {{ odds[0] }}
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            @click="smallClick"
            v-model="small"
            :color="b ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            small {{ odds[1] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="12">
          <van-button
            @click="singleClick"
            v-model="single"
            :color="c ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            single {{ odds[2] }}
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            @click="doubleClick"
            v-model="double"
            :color="d ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            double {{ odds[3] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="12">
          <van-button
            @click="bigSingleClick"
            v-model="bigSingle"
            :color="e ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            BigSingle {{ odds[4] }}
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            @click="bigDoubleClick"
            v-model="bigDouble"
            :color="f ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            BigDouble {{ odds[5] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="12">
          <van-button
            @click="smallSingleClick"
            v-model="smallSingle"
            :color="g ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            SmallSingle {{odds[6]}}
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            @click="littleDoubleClick"
            v-model="littleDouble"
            :color="h ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            LittleDouble {{odds[7]}}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="12">
          <van-button
            @click="greatClick"
            v-model="great"
            :color="i ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
            >Great {{odds[8]}}</van-button
          >
        </van-col>
        <van-col span="12">
          <van-button
            @click="minimalClick"
            v-model="minimal"
            :color="j ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
            >Minimal {{odds[9]}}</van-button
          >
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="redWaveClick"
            v-model="redWave"
            :color="k ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >RedWave {{odds[11]}}</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button
            @click="greenWaveClick"
            v-model="greenWave"
            :color="l ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >GreenWave {{odds[12]}}</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button
            @click="blueWaveClick"
            v-model="blueWave"
            :color="m ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >BlueWave {{odds[13]}}</van-button
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "sizetab",
  props: ["target", "odds", "combination", "clear"],
  data() {
    return {
      big: "",
      a: false,
      small: "",
      b: false,
      single: "",
      c: false,
      double: "",
      d: false,
      bigSingle: "",
      e: false,
      bigDouble: "",
      f: false,
      smallSingle: "",
      g: false,
      littleDouble: "",
      h: false,
      great: "",
      i: false,
      minimal: "",
      j: false,
      redWave: "",
      k: false,
      greenWave: "",
      l: false,
      blueWave: "",
      m: false,
      value: [],
      distVal: {
        val: "",
        total: 0
      }
    };
  },
  created() {
  },
  watch: {
    combination(newValue, oldValue) {
      if(newValue) {
        this.value.forEach((v,i)=>{
          this.distVal.val += v+";";
        })
        this.distVal.total = this.value.length;
        this.$emit('size',this.distVal);
      }
    },
    clear(newValue, oldValue) {
      if(newValue) {
        this.initOrigin()
      }
    }
  },
  methods: {
    bigClick() {
      this.a = !this.a;
      if (this.a) {
        this.big = this.target[0];
        this.value.push(this.big);
      } else {
        this.value.map((val, i) => {
          if(val === this.big) {
            this.value.splice(i, 1);
          }
        })
        this.big = "";
      }
    },
    smallClick() {
      this.b = !this.b;
      if (this.b) {
        this.small = this.target[1];
        this.value.push(this.small);
      } else {
        this.value.map((val, i) => {
          if(val === this.small) {
            this.value.splice(i, 1);
          }
        })
        this.small = "";
      }
    },
    singleClick() {
      this.c = !this.c;
      if (this.c) {
        this.single = this.target[2];
        this.value.push(this.single);
      } else {
        this.value.map((val, i) => {
          if(val === this.single) {
            this.value.splice(i, 1);
          }
        })
        this.single = "";
      }
    },
    doubleClick() {
      this.d = !this.d;
      if (this.d) {
        this.double = this.target[3];
        this.value.push(this.double);
      } else {
        this.value.map((val, i) => {
          if(val === this.double) {
            this.value.splice(i, 1);
          }
        })
        this.double = "";
      }
    },
    bigSingleClick() {
      this.e = !this.e;
      if (this.e) {
        this.bigSingle = this.target[4];
        this.value.push(this.bigSingle);
      } else {
        this.value.map((val, i) => {
          if(val === this.bigSingle) {
            this.value.splice(i, 1);
          }
        })
        this.bigSingle = "";
      }
    },
    bigDoubleClick() {
      this.f = !this.f;
      if (this.f) {
        this.bigDouble = this.target[5];
        this.value.push(this.bigDouble);
      } else {
        this.value.map((val, i) => {
          if(val === this.bigDouble) {
            this.value.splice(i, 1);
          }
        })
        this.bigDouble = "";
      }
    },
    smallSingleClick() {
      this.g = !this.g;
      if (this.g) {
        this.smallSingle = this.target[6];
        this.value.push(this.smallSingle);
      } else {
        this.value.map((val, i) => {
          if(val === this.smallSingle) {
            this.value.splice(i, 1);
          }
        })
        this.smallSingle = "";
      }
    },
    littleDoubleClick() {
      this.h = !this.h;
      if (this.h) {
        this.littleDouble = this.target[7];
        this.value.push(this.littleDouble);
      } else {
        this.value.map((val, i) => {
          if(val === this.littleDouble) {
            this.value.splice(i, 1);
          }
        })
        this.littleDouble = "";
      }
    },
    greatClick() {
      this.i = !this.i;
      if (this.i) {
        this.great = this.target[8];
        this.value.push(this.great);
      } else {
        this.value.map((val, i) => {
          if(val === this.great) {
            this.value.splice(i, 1);
          }
        })
        this.great = "";
      }
    },
    minimalClick() {
      this.j = !this.j;
      if (this.j) {
        this.minimal = this.target[9];
        this.value.push(this.minimal);
      } else {
        this.value.map((val, i) => {
          if(val === this.minimal) {
            this.value.splice(i, 1);
          }
        })
        this.minimal = "";
      }
    },
    redWaveClick() {
      this.k = !this.k;
      if (this.k) {
        this.redWave = this.target[11];
        this.value.push(this.redWave);
      } else {
        this.value.map((val, i) => {
          if(val === this.redWave) {
            this.value.splice(i, 1);
          }
        })
        this.redWave = "";
      }
    },
    greenWaveClick() {
      this.l = !this.l;
      if (this.l) {
        this.greenWave = this.target[12];
        this.value.push(this.greenWave);
      } else {
        this.value.map((val, i) => {
          if(val === this.greenWave) {
            this.value.splice(i, 1);
          }
        })
        this.greenWave = "";
      }
    },
    blueWaveClick() {
      this.m = !this.m;
      if (this.m) {
        this.blueWave = this.target[13];
        this.value.push(this.blueWave);
      } else {
        this.value.map((val, i) => {
          if(val === this.blueWave) {
            this.value.splice(i, 1);
          }
        })
        this.blueWave = "";
      }
    },
    initOrigin() {
      this.a = false;
      this.b = false;
      this.c = false;
      this.d = false;
      this.e = false;
      this.f = false;
      this.g = false;
      this.h = false;
      this.i = false;
      this.j = false;
      this.k = false;
      this.l = false;
      this.m = false;
      this.value = [];
      this.distVal = {
        val: "",
        total: 0
      }
    },
  },
};
</script>

<style>
.drawer-card {
  padding: 20px;
}

.button-style {
  border: 1px solid;
}
</style>
